<template>
<Expose class="design" :ratio="0.2" @expose="$emit('expose')">
    <div class="design-content">
        <template v-for="(item, index) in items">
            <Item v-bind="item" :key="index" :style="{flex: 1}" :id="index"/>
        </template>
    </div>
</Expose>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
import Item from './Item';
import { ITEMS } from './config';
import Expose from '../../../expose';
export default {
  name: 'design-template',
  components: {
    Item,
    Expose
  },
  computed: {
    items() {
      return ITEMS;
    }

  }
};
</script>
<style scoped>
.design {
  padding: 16px;
  width: 656px;
  height: 280px;
  background: #3E3E3F;
  box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.4);
  border-radius: 8px;
}
.design-content {
  display: flex;
}

</style>
